import { createContext, useContext } from 'react';
import { DrawerContent } from '@setvi/shared/enums';
import { Recipient, Link } from '@setvi/shared/interfaces';
import { EditorProduct } from '@setvi/shared/components/seditor/interfaces';
import { ComposeEmailValues } from '../hook';

const initialValues = {
  sendTo: [] as Recipient[],
  textBody: '',
  subject: '',
  body: ''
};

export interface openComposeProps {
  linksData?: Link | Link[];
  drawerContent?: DrawerContent;
  emailBody?: string;
  subject?: string;
  recipients?: Recipient[];
  products?: EditorProduct[];
}

export type ComposeEmailContextType = {
  values: ComposeEmailValues;
  links: Array<Link>;
  editorNode: any;
  editorValues: any;
  open: (
    { linksData, drawerContent, subject, recipients }: openComposeProps,
    disableOpening?: boolean
  ) => void;
  close: () => void;
};

const contextDefaultValues: ComposeEmailContextType = {
  values: initialValues,
  links: [],
  editorNode: null,
  editorValues: {},
  open: () => {},
  close: () => {}
};

export const ComposeEmailContext =
  createContext<ComposeEmailContextType>(contextDefaultValues);

export const useComposeEmail = () => {
  const context = useContext(ComposeEmailContext);

  // if `undefined`, throw an error
  if (context === undefined)
    throw new Error('useComposeEmail was used outside of its Provider');

  return context;
};
